<template>
    <div id="basic-card" class="home-page">
        <div class="vx-row">
            <div class="loader-block loader-block2" v-if="axiosInstance">
                <div class="loading">
                    <div class="effect-1 effects"></div>
                    <div class="effect-2 effects"></div>
                    <div class="effect-3 effects"></div>
                </div>
            </div>
            <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0">{{ isDeletePage ? 'Deleted assets' : 'Assets' }}</h2>

            <vx-card>
                <div class="d-flex justify-between">
                    <div class="d-flex">
                        <vs-input class=" vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                                  placeholder="Search here"
                                  v-on:keyup="getSearchData"
                                  style="margin-right: 10px;width: 300px"
                                  v-model="searchQuery"/>
                        <div style="width: 160px" v-if="!isDeletePage">
                            <v-select name="type"
                                      v-validate="'required'" :options="types"
                                      v-model="asset_type"
                                      @input="getSearchData"
                                      :clearable="false"
                                      label="name"
                                      :reduce="item => item.value"/>
                            <span class="text-danger text-sm validation-error"
                                  v-show="errors.has('type')">{{ errors.first('type') }}</span>

                        </div>
                    </div>
                    <div class="d-flex" v-if="!isDeletePage">
                        <div style="width: 160px;margin-right: 10px;">
                            <v-select name="type"
                                      v-validate="'required'" :options="types"
                                      v-model="replace_asset_type"
                                      :clearable="false"
                                      label="name"
                                      :reduce="item => item.value"/>
                            <span class="text-danger text-sm validation-error"
                                  v-show="errors.has('type')">{{ errors.first('type') }}</span>

                        </div>
                        <vs-button :class="{'pen': isLoading}" v-on:click="updateAssets">Update</vs-button>
                    </div>
                    <div class="d-flex" v-if="isDeletePage">
                        <vs-button :class="{'pen': isLoading}" v-on:click="restoreAssets">Restore</vs-button>
                    </div>
                </div>
                <div id="data-container" style="min-height: 30px; margin-top: 20px" class="relative">
                    <table v-if="items && items.length > 0"
                           class="data-table mt-3">
                        <thead>
                        <th style="width: 7%">
                            <vs-checkbox :value="Object.values(selected).filter(item => item).length == items.length" @change="selectAll" />
                        </th>
                        <th style="width: 15%">Title</th>
                        <th style="width: 8%">Type</th>
                        <th style="width: 20%">Tags</th>
                        <th style="width: 15%">Subject</th>
                        <th style="width: 15%">Thumbnail</th>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                            <td>
                                <div>
                                    <vs-checkbox v-model="selected[item._id]"/>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <router-link :to="$store.state.user.role.name === 'Authenticated' ? ('/' + item._id) : ('/' + item._id + '/edit')">
                                        {{item.title}}
                                    </router-link>
                                </div>
                            </td>
                            <td>
                                <div>
                                    {{item.asset_type}}
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div v-for="(el, index) in item.keywords"
                                         :key="index"
                                         class="con-vs-chip vs-chip-dark con-color"
                                         style="color: rgba(255, 255, 255, 0.9);">
                                        <span class="text-chip vs-chip--text">{{ el }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div v-for="(el, index) in item.subject"
                                         :key="index"
                                         class="con-vs-chip vs-chip-dark con-color"
                                         style="color: rgba(255, 255, 255, 0.9);">
                                        <span class="text-chip vs-chip--text">{{ el }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="asset-thumbnail-block">
                                    <div class="asset-thumbnail-section">
                                        <HoverThumb :main="item.thumbnail" :list="item.thumbnails" :asset="item"/>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pagination-block">
                    <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1"
                                   @change="handlePaginationChange"></vs-pagination>
                </div>
            </vx-card>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import vSelect from 'vue-select'
    import HoverThumb from "../components/HoverThumb";
    export default {
        name: 'DataAssets',
        components: {
            HoverThumb,
            vSelect
        },
        head() {
            return {
                title: {
                    inner: 'AMP',
                    separator: ' ',
                    complement: ''
                },
                meta: [
                    {hid: 'description', name: 'description', content: ''}
                ]
            }
        },
        data() {
            return {
                orderBy: {
                    'order': 'desc',
                    'order_by': 'updatedAt'
                },
                searchQuery: '',
                isDeletePage: false,
                isLoading: false,
                axiosInstance: false,
                axiosInstance2: false,
                debounce: false,
                items: [],
                mediaItems: [],
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 24,
                totalPages: 0,
                isMounted: false,
                isMounted2: false,
                selected: {},
                types: this.$store.getters.assetTypes,
                asset_type: '3D',
                replace_asset_type: '3D',
            }
        },
        computed: {},
        mounted() {
            if (this.$route.name === 'deleted-assets') {
                this.isDeletePage = true;
            }
            if (this.$route.query.asset_type) {
                this.asset_type = +this.$route.query.asset_type;
            }
            if (this.$route.query.page) {
                this.currentPage = +this.$route.query.page;
            }
            if (this.$route.query.per_page) {
                this.itemsPerPage = +this.$route.query.per_page;
            }

            if (this.$route.query.order && this.$route.query.order_by) {
                this.orderBy = {
                    order_by: this.$route.query.order_by,
                    order: this.$route.query.order
                };
            }
            this.search();
        },
        methods: {
            selectAll() {
                this.selected = Object.values(this.selected).filter(item => item).length === this.items.length ? {} : this.items.reduce((obj, val) => { obj[val._id] = true; return obj}, {})
            },
            updateAssets() {
                let ids = Object.keys(this.selected).filter(item => this.selected[item]);
                if (ids && ids.length) {
                    this.isLoading = true;

                    let url = '/assets/sync-asset-types';
                    let data = {
                        ids: ids,
                        asset_type: this.replace_asset_type
                    }
                    this.$axios.post(url, data).then(res => {
                        this.isLoading = false;
                        this.selected = {};
                        this.getSearchData();
                        this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Update Successful'})
                    }).catch(e => {
                        this.isLoading = false;
                        console.log('catch_search', e)
                    });
                } else {
                    this.$vs.notifyWrapper({color: 'danger', title: 'Validation error', text: 'Select some fields'})
                }
            },
            restoreAssets() {
                let ids = Object.keys(this.selected).filter(item => this.selected[item]);
                if (ids && ids.length) {
                    this.isLoading = true;

                    let url = '/deleted-assets/restore';
                    let data = {
                        ids: ids,
                    }
                    this.$axios.post(url, data).then(res => {
                        this.isLoading = false;
                        this.selected = {};
                        this.getSearchData();
                        this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Update Successful'})
                    }).catch(e => {
                        this.isLoading = false;
                        console.log('catch_search', e)
                    });
                } else {
                    this.$vs.notifyWrapper({color: 'danger', title: 'Validation error', text: 'Select some fields'})
                }
            },
            updateUrl() {
                let path = this.$route.path;
                let qObj = {
                    per_page: this.itemsPerPage
                };
                if (this.orderBy && this.orderBy.order && this.orderBy.order_by) {
                    qObj.order_by = this.orderBy.order_by;
                    qObj.order = this.orderBy.order;
                }
                if (this.currentPage !== 1) {
                    qObj.page = this.currentPage;
                }
                if (this.asset_type) {
                    qObj.asset_type = this.asset_type;
                }
                if (this.$store.state.searchQuery) {
                    qObj.search = this.$store.state.searchQuery;
                }
                let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                let q = "?" + new URLSearchParams(qArr).toString()
                history.pushState(
                    {},
                    null,
                    path+q
                )
            },
            handlePaginationChange() {
                if (this.isMounted) {
                    this.items = [];
                    this.search();
                }
            },
            getSearchData() {
                clearTimeout(this.debounce);
                this.debounce = setTimeout(() => {
                    this.currentPage = 1;
                    this.search()
                }, 500)

            },
            search() {
                this.updateUrl();
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                const source2 = CancelToken.source();

                let url = `/assets/search`;
                if (this.isDeletePage) {
                    url = '/deleted-assets'
                }
                let qObj = {
                    _limit: this.itemsPerPage,
                    _start: (this.currentPage - 1) * this.itemsPerPage
                };

                if (this.orderBy) {
                    qObj._sort = `${this.orderBy.order_by}:${this.orderBy.order}`
                }
                if (this.searchQuery) {
                    if (this.isDeletePage) {
                        qObj._q = this.searchQuery;

                    } else {
                        qObj._search = this.searchQuery;
                    }
                }
                if (this.asset_type && !this.isDeletePage) {
                    qObj.asset_types = JSON.stringify([this.asset_type]);
                }
                let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                let q = "?" + new URLSearchParams(qArr).toString()
                url += q;
                if (this.axiosInstance) {
                    this.axiosInstance.cancel();
                }
                this.showImages = false;
                this.axiosInstance = source;

                this.$axios.get(url, {cancelToken: source.token}).then(res => {
                    this.items = res.data;
                    this.axiosInstance = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)
                    this.isMounted2 = false;

                    if (!this.isMounted) {
                        setTimeout(() => {
                            this.isMounted = true;
                        }, 200)
                    }
                }).catch(e => {
                    this.axiosInstance = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)
                    console.log('catch_search', e)
                });

                let url2 = `/assets/search/count`
                if (this.isDeletePage) {
                    url2 = '/deleted-assets/count'
                }
                delete qObj._sort;
                delete qObj._limit;
                delete qObj._start;
                qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                q = "?" + new URLSearchParams(qArr).toString()
                url2 += q;
                if (this.axiosInstance2) {
                    this.axiosInstance2.cancel();
                }
                this.axiosInstance2 = source2;
                this.$axios.get(url2, {cancelToken: source2.token}).then(res => {
                    this.totalItems = res.data;
                    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
                    this.axiosInstance2 = false;
                }).catch(e => {
                    console.log('catch_search', e)
                })
            },
            changePerPage(limit) {
                this.itemsPerPage = limit;
                setTimeout(() => {
                    this.search()
                }, 10)
            }
        },
        watch: {

        },
    }
</script>
